import { isString } from "@payair/e-com-common-sdk/core/Validators";
/** @internal */
export var validateApplePayPaymentContact = function (applePayPaymentContact) {
    var errorMessage = [];
    if (applePayPaymentContact.emailAddress !== undefined && !isString(applePayPaymentContact.emailAddress))
        errorMessage.push("emailAddress is not a string");
    if (applePayPaymentContact.familyName !== undefined && !isString(applePayPaymentContact.familyName))
        errorMessage.push("familyName is not a string");
    if (applePayPaymentContact.givenName !== undefined && !isString(applePayPaymentContact.givenName))
        errorMessage.push("givenName is not a string");
    if (applePayPaymentContact.phoneNumber !== undefined && !isString(applePayPaymentContact.phoneNumber))
        errorMessage.push("phoneNumber is not a string");
    if (applePayPaymentContact.phoneticFamilyName !== undefined && !isString(applePayPaymentContact.phoneticFamilyName))
        errorMessage.push("phoneticFamilyName is not a string");
    if (applePayPaymentContact.phoneticGivenName !== undefined && !isString(applePayPaymentContact.phoneticGivenName))
        errorMessage.push("phoneticGivenName is not a string");
    if (applePayPaymentContact.addressLines !== undefined) {
        if (!Array.isArray(applePayPaymentContact.addressLines))
            errorMessage.push("addressLines is not an array");
        else {
            applePayPaymentContact.addressLines.forEach(function (addressLine) {
                if (!isString(addressLine))
                    errorMessage.push("".concat(addressLine, " in addressLines array is not a string"));
            });
        }
    }
    if (applePayPaymentContact.locality !== undefined && !isString(applePayPaymentContact.locality))
        errorMessage.push("locality is not a string");
    if (applePayPaymentContact.subLocality !== undefined && !isString(applePayPaymentContact.subLocality))
        errorMessage.push("subLocality is not a string");
    if (applePayPaymentContact.administrativeArea !== undefined && !isString(applePayPaymentContact.administrativeArea))
        errorMessage.push("administrativeArea is not a string");
    if (applePayPaymentContact.subAdministrativeArea !== undefined &&
        !isString(applePayPaymentContact.subAdministrativeArea))
        errorMessage.push("subAdministrativeArea is not a string");
    if (applePayPaymentContact.postalCode !== undefined && !isString(applePayPaymentContact.postalCode))
        errorMessage.push("postalCode is not a string");
    if (applePayPaymentContact.country !== undefined && !isString(applePayPaymentContact.country))
        errorMessage.push("country is not a string");
    if (applePayPaymentContact.countryCode !== undefined && !isString(applePayPaymentContact.countryCode))
        errorMessage.push("countryCode is not a string");
    return errorMessage;
};
